<ion-row class="w-100 hp-85">
  <ion-col size="6" class="p-16">
    <ion-img [src]="'logo' | getImagePipe:2" ></ion-img>
  </ion-col>
  <ion-col size="6" class="flex flex-col ion-justify-content-center">
    <ion-text class="lbl-bold-15">{{'welcome' | getLanguagePipe}}</ion-text>
    <ion-text class="lbl-10 user-ml">{{'visitor' | getLanguagePipe}}</ion-text>
  </ion-col>
</ion-row>